import { useState } from "react";
import { toast } from "sonner";
import { Upload, FileSpreadsheet, Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import api, { download, errMsg } from "@/lib/api";

export const ImportDialog = ({ entity, title, onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async () => {
    if (!file) return toast.error("Pilih file Excel/CSV terlebih dahulu");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/import/${entity}`, fd);
      setResult(data);
      toast.success(`${data.inserted} data berhasil diimport`);
      onDone && onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
    <Button variant="outline" className="bg-white" data-testid={`template-${entity}-btn`} onClick={() => download(`/import/template/${entity}`, {}, `template-${entity}.xlsx`)}>
      <Download className="h-4 w-4 mr-2" />Template
    </Button>
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) { setFile(null); setResult(null); } }}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid={`import-${entity}-btn`} className="bg-white"><Upload className="h-4 w-4 mr-2" />Import</Button>
      </DialogTrigger>
      <DialogContent aria-describedby={undefined} className="max-w-lg">
        <DialogHeader><DialogTitle className="font-heading">Import {title}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Button variant="secondary" data-testid={`import-${entity}-template-btn`} onClick={() => download(`/import/template/${entity}`, {}, `template-${entity}.xlsx`)}>
            <Download className="h-4 w-4 mr-2" />Download Template Excel
          </Button>
          <label className="flex cursor-pointer flex-col items-center gap-2 rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 p-8 text-center hover:border-blue-400 transition-colors">
            <FileSpreadsheet className="h-10 w-10 text-blue-800" />
            <span className="text-sm font-medium">{file ? file.name : "Klik untuk pilih file .xlsx / .csv"}</span>
            <input type="file" accept=".xlsx,.xls,.csv" className="hidden" data-testid={`import-${entity}-file-input`} onChange={(e) => setFile(e.target.files[0])} />
          </label>
          {result && (
            <div data-testid={`import-${entity}-result`} className="rounded-lg bg-slate-50 p-3 text-sm">
              <p className="font-semibold text-emerald-700">{result.inserted} data berhasil diimport</p>
              {result.errors?.map((er) => <p key={er} className="text-rose-600 text-xs">{er}</p>)}
            </div>
          )}
          <Button className="w-full" disabled={busy} onClick={submit} data-testid={`import-${entity}-submit-btn`}>{busy ? "Mengimport..." : "Import Sekarang"}</Button>
        </div>
      </DialogContent>
    </Dialog>
    </>
  );
};
